var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("app-header"),
      _vm._v(" "),
      _c("router-view"),
      _vm._v(" "),
      _c("app-footer"),
      _vm._v(" "),
      _c("login-modal", {
        ref: "loginModal",
        on: { openAppModal: _vm.openModal }
      }),
      _vm._v(" "),
      _c(
        "sweet-modal",
        {
          ref: "logoutModal",
          attrs: { "overlay-theme": "dark", icon: "success" }
        },
        [
          _vm._v(
            "\n    " + _vm._s(_vm.$t("message.logout.logout_success")) + "\n  "
          )
        ]
      ),
      _vm._v(" "),
      _c("request-email-modal", {
        ref: "requestEmailModal",
        attrs: { loginData: _vm.loginData }
      }),
      _vm._v(" "),
      _c("loader-modal", { ref: "loaderModal" }),
      _vm._v(" "),
      _c(
        "sweet-modal",
        {
          ref: "successRegisterModal",
          attrs: { "overlay-theme": "dark", icon: "success" }
        },
        [
          _vm._v(
            "\n    " +
              _vm._s(
                _vm.$t("message.login.confirm_email_to_activate_account")
              ) +
              "\n  "
          )
        ]
      ),
      _vm._v(" "),
      _c("success-booking-modal"),
      _vm._v(" "),
      _c("phone-verification-modal", { ref: "phoneVerificationModal" }),
      _vm._v(" "),
      _c("line-verification-modal", { ref: "lineVerificationModal" }),
      _vm._v(" "),
      _c("line-contact-modal", { ref: "lineContactModal" }),
      _vm._v(" "),
      _c("professional-service-modal", { ref: "profServiceModal" }),
      _vm._v(" "),
      _c("confirm-personal-topic-modal", { ref: "confirmPersonalTopicModal" }),
      _vm._v(" "),
      _c("div", {
        class: { "d-none": !_vm.globalState.displayFBChat },
        attrs: { id: "fb-root" }
      }),
      _vm._v(" "),
      _c(
        "section",
        {
          class: _vm.isHiddenChatButton,
          attrs: { id: "floating-icon-contacts" }
        },
        [
          _c(
            "div",
            {
              ref: "fab-container-floating-button",
              staticClass: "fab-container",
              on: {
                mousemove: function($event) {
                  return _vm.onMouseMoveFloatingButton($event)
                },
                mouseleave: function($event) {
                  return _vm.onMouseLeaveFloatingButton($event)
                },
                click: function($event) {
                  return _vm.onClickFloatingButton($event)
                }
              }
            },
            [_vm._m(0)]
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "fab shadow" }, [
      _c("div", { staticClass: "fab-content" }, [
        _c("span", { staticClass: "material-icons" }, [
          _c(
            "a",
            {
              attrs: {
                href: "https://line.me/R/ti/p/%40hnk7011n",
                target: "_blank"
              }
            },
            [
              _c("img", {
                staticClass: "img-fluid rounded-circle",
                attrs: {
                  src: "/static/img/floatingButton/line.png",
                  "data-platform": "line",
                  width: "80"
                }
              })
            ]
          )
        ])
      ])
    ])
  }
]
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7ba5bd90", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7ba5bd90","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 1472
// module chunks = 0